<template>
  <AppCard design="new" variant="table" header-density="compact">
    <AppDataTable design="new" density="dense" :columns="columns" :rows="rows" clickable min-width="1200px" @row-click="open($event.row, $event.event)">
      <template #cell="{ row, column }">
        <span v-if="column.key === 'id'" class="ui-cell-inline">
          <AppTableText :text="row.id === null || row.id === undefined ? '' : String(row.id)" />
          <OperationsCopyButton v-if="row.id !== null && row.id !== undefined && String(row.id)" :value="String(row.id)" />
        </span>
        <span v-else-if="column.key === 'result' && row.result" class="ui-cell-inline">
          <AppStatusBadge design="new" compact :tone="color(row.result.status)" :label="row.result.label" />
          <i v-if="resultInfo(row.result)" v-tooltip="tip(resultInfo(row.result))" class="pi pi-info-circle ui-tooltip-target" tabindex="0" :aria-label="resultInfo(row.result)" />
        </span>
        <AppTableText v-else :text="column.key === 'result' ? '' : value(row, column.key)" :tooltip="extraInfo(row, column.key)" />
      </template>
    </AppDataTable>
  </AppCard>
</template>

<script>
import AppTableText from '@/components/AppTableText.vue'
import OperationsCopyButton from './OperationsCopyButton.vue'
import RecordTable from './RecordTable.vue'
import { dateLabel, humanize, tone } from './model'

export default {
  name: 'IntegrationLogsTable',
  extends: RecordTable,
  components: { AppTableText, OperationsCopyButton },
  methods: {
    color: tone,
    resultInfo(result) {
      const details = []
      if (result.domain) details.push(humanize(result.domain))
      if (result.message && result.message !== result.label) details.push(result.message)
      return details.join(': ')
    },
    extraInfo(row, key) {
      if (key === 'created_at' && row.created_at) return dateLabel(row.created_at, true)
      if (key === 'destination' && row.destination?.items?.length > 1) return row.destination.items.map(item => [item.label, item.address].filter(Boolean).join(' · ')).join('\n')
      return ''
    }
  }
}
</script>
